import { EnumOption } from 'common/enum-value';
import { SelectOptionType } from 'utils/react-table';

type VenueTypeDto = {
    id: number;
    name: string;
};

export const mapVenueTypeToSelectOption = (venueTypes: Array<VenueTypeDto>): Array<SelectOptionType> => {
    return venueTypes.map((venueTypes) => ({ value: venueTypes.id, label: venueTypes.name }));
};

export function mapVenueTypeToEnumOption(venueTypes: Array<VenueTypeDto>): Array<EnumOption> {
    if (!venueTypes) return [{ value: 0, label: 'undefined' }];
    return [{ value: -1, label: 'Not assigned' },
        ...venueTypes.map((venueType) => ({
            value: venueType.id,
            label: venueType.name,
    }))];
}

export default VenueTypeDto;
